import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const CalendarX: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '3', y: '4', width: '18', height: '18', rx: '2', ry: '2' }],
    ['line', { x1: '16', y1: '2', x2: '16', y2: '6' }],
    ['line', { x1: '8', y1: '2', x2: '8', y2: '6' }],
    ['line', { x1: '3', y1: '10', x2: '21', y2: '10' }],
    ['line', { x1: '10', y1: '14', x2: '14', y2: '18' }],
    ['line', { x1: '14', y1: '14', x2: '10', y2: '18' }],
  ],
];

export default CalendarX;
